import styled from 'styled-components';
import { max, min } from '../lib/responsive';
import { GraphicGridDesktop } from '../lib/shared';
import { LargeP } from '../style/typography';

const TeamImage = styled.img`
  max-width: 100%;
  height: auto;
  margin-top: 7rem;
  margin-bottom: 18rem;

  @media ${max.tabletLg} {
    margin-top: 1rem;
    margin-bottom: 3rem;
  }
`;

const AboutPageDescription = styled(LargeP)`
  width: 100%;

  margin: 5rem 0;
  @media ${min.tablet} {
    margin: 8rem 0;
  }
  @media ${min.tabletLg} {
    width: 65%;
    padding-left: 15rem;
  }
  @media ${min.desktop} {
    margin: 10rem 0;
    padding-left: 20rem;
  }
`;

const AboutGraphicGridDesktop1 = styled(GraphicGridDesktop)`
  width: 97.5%;
`;

export { AboutPageDescription, TeamImage, AboutGraphicGridDesktop1 };
